const FAVORITES_KEY = 'halisaha_favorites';

function readFavorites(): string[] {
  try {
    const raw = localStorage.getItem(FAVORITES_KEY);
    if (!raw) return [];
    return JSON.parse(raw) as string[];
  } catch {
    return [];
  }
}

function writeFavorites(list: string[]) {
  localStorage.setItem(FAVORITES_KEY, JSON.stringify(list));
}

export function getFavorites(): string[] {
  return readFavorites();
}

export function isFavorite(fieldId: string): boolean {
  return readFavorites().includes(fieldId);
}

export function toggleFavorite(fieldId: string): boolean {
  const list = readFavorites();
  const index = list.indexOf(fieldId);
  if (index >= 0) {
    list.splice(index, 1);
    writeFavorites(list);
    return false;
  } else {
    list.push(fieldId);
    writeFavorites(list);
    return true;
  }
}

export function removeFavorite(fieldId: string): void {
  const list = readFavorites().filter(id => id !== fieldId);
  writeFavorites(list);
}

export function getFavoriteCount(): number {
  return readFavorites().length;
}
